module.exports = __webpack_public_path__ + "img/44.0201dc05.png";